import styled from 'styled-components';

interface tabsContent {
	padding?: string;
	active?: boolean;
}

const TabsContent = styled.div<tabsContent>`
	width: 100%;
	padding: 24px;
	display: none;
	padding: ${({ padding }) => padding};
	${({ active }) =>
		active &&
		`display: inline-block;
	`};
`;

export default TabsContent;
